import {Component, Inject, OnInit} from '@angular/core';
import {Permission} from '@domain/profile/permission.enum';
import {AUTHENTICATION, Authentication} from '@infrastructure/http/authentication/authentication';
import {DownloadUrls, DOWNLOAD_URLS} from '@infrastructure/http/download-urls/download-urls';
import {BaseComponent} from '@vdw/angular-component-library';
import {takeUntil} from 'rxjs';

@Component({
  selector: 'app-tuft-link-page',
  templateUrl: './tuft-link-page.component.html'
})
export class TuftLinkPageComponent extends BaseComponent implements OnInit {
  public readonly TUFT_LINK_PERMISSION = Permission.TEXEDIT_TUFTLINK;
  public tuftLinkDownloadUrl: string;

  public constructor(
    @Inject(DOWNLOAD_URLS) private readonly downloadUrlsService: DownloadUrls,
    @Inject(AUTHENTICATION) private readonly authentication: Authentication
  ) {
    super();
  }

  public ngOnInit(): void {
    if (this.authentication.getCurrentSubscription().hasPermission(this.TUFT_LINK_PERMISSION)) {
      this.getTuftLinkDownloadUrl();
    }
  }

  private getTuftLinkDownloadUrl(): void {
    this.downloadUrlsService
      .getTuftLinkDownloadUrl()
      .pipe(takeUntil(this.unSubscribeOnViewDestroy))
      .subscribe((tuftEndpoint: string) => (this.tuftLinkDownloadUrl = tuftEndpoint));
  }
}
